/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgFolderXSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgFolderXSolid"
    {...props}
  >
    {props.children}
    <path
      fill="#000"
      fillRule="evenodd"
      d="M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231m-1.297 6.738a1 1 0 0 1 1.414 0L12 12.586l1.793-1.793a1 1 0 0 1 1.414 1.414L13.414 14l1.793 1.793a1 1 0 0 1-1.414 1.414L12 15.414l-1.793 1.793a1 1 0 0 1-1.414-1.414L10.586 14l-1.793-1.793a1 1 0 0 1 0-1.414"
      clipRule="evenodd"
    />
  </svg>
)
